import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/person_gray_150.png'
import _imports_1 from '@/assets/icons/person_dotted_80.png'


const _withScopeId = n => (_pushScopeId("data-v-0868930e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "status-icon"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "member-area" }
const _hoisted_4 = {
  key: 1,
  src: _imports_0,
  class: "member-icon"
}
const _hoisted_5 = {
  key: 2,
  src: _imports_1,
  class: "member-icon"
}
const _hoisted_6 = { class: "member-name" }
const _hoisted_7 = {
  key: 0,
  class: "deceased"
}

import { computed, inject } from 'vue'
import { PotentialMember } from '@/manage/familygroups/FamilyGroupMemberManager'
import { GroupMemberRole } from '@/gp/GroupAdminModel'
import { ProfileSharingState } from './ProfileSharingState'


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyGroupPotentialMember',
  props: {
    pm: {},
    allowAdd: { type: Boolean },
    sharingMode: { type: Boolean },
    hideStatus: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["click", "invite"],
  setup(__props: any, { emit }) {

const props = __props;





const profileSharingState = inject<ProfileSharingState>('profileSharingState')!

const selectedRef = computed({
  get: () => profileSharingState.isShared(props.pm.profileGroupId),
  set: value => profileSharingState.shareProfiles([props.pm.profileGroupId!], value)
})

const memIsOwnerRef = computed(() => props.pm.member?.role == GroupMemberRole.Owner)
const isProfileSharedRef = computed(() => profileSharingState.isShared(props.pm.profileGroupId!))
const canSelectRef = computed(() => props.pm.canModifyProfile && !props.pm.hasPendingGroupInvite)
const canInviteOthersRef = computed(() => props.pm.member?.canInviteOthers)
const showGroupInviteActionRef = computed(() => props.allowAdd && isProfileSharedRef.value && props.pm.canBeInvited)
const showSharingInviteRef = computed(() => !isProfileSharedRef.value && props.pm.lastSharingInvite?.isPending)

const itemTypeRef = computed(() => {
  const classes: string[] = []
  let text = ''
  if (memIsOwnerRef.value && !props.hideStatus) {
    classes.push('owner')
    text = 'Owner'
  }
  else if (canInviteOthersRef.value) {
    classes.push('recruiter')
    text = 'Member'
  }
  else if (props.pm.member) {
    classes.push('member')
    text = 'Member'
  }
  else if (isProfileSharedRef.value) {
    classes.push('profile')
    text = 'Shared profile'
  }
  else {
    classes.push('suggested')
    text = 'Suggested member'
  }

  if (showSharingInviteRef.value) {
    classes.push('sharing-invite')
    text = 'Share requested'
  }
  if (props.pm.hasPendingGroupInvite) {
    classes.push('group-invite')
    text = 'Invited'
  }

  return { classes, text }
})

const displayNameRef = computed(() => props.pm.displayName ?? '(no name)')


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["potential-member", itemTypeRef.value.classes])
  }, [
    (!_ctx.hideStatus)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.sharingMode)
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 1,
          type: "checkbox",
          class: "form-check-input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedRef).value = $event)),
          disabled: !canSelectRef.value
        }, null, 8, _hoisted_2)), [
          [_vModelCheckbox, selectedRef.value]
        ])
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.disabled)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "overlay",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('click')))
          }))
        : _createCommentVNode("", true),
      (isProfileSharedRef.value)
        ? (_openBlock(), _createElementBlock("img", _hoisted_4))
        : (_openBlock(), _createElementBlock("img", _hoisted_5)),
      _createElementVNode("div", _hoisted_6, [
        _createTextVNode(_toDisplayString(displayNameRef.value) + " ", 1),
        (_ctx.pm.profilePerson?.displayProperties.assumeDeceased)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "(deceased)"))
          : _createCommentVNode("", true)
      ])
    ]),
    (showGroupInviteActionRef.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          type: "button",
          class: "btn btn-inline btn-link member-action",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('invite')))
        }, "Invite"))
      : _createCommentVNode("", true)
  ], 2))
}
}

})